// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Diamond20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Diamond20: FC<Diamond20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M10 17 3 9.812 7 5h6l4 4.813L10 17ZM4.438 5 2.667 3.23l1.062-1.063L5.5 3.937 4.438 5ZM9.25 3.5V1h1.5v2.5h-1.5ZM15.542 5l-1.063-1.063 1.771-1.77 1.063 1.062L15.542 5ZM10 14.854l4.25-4.354h-8.5L10 14.854ZM7.71 6.5 5.625 9h8.73l-2.063-2.5H7.709Z" />
        </svg>
    );
};

export default Diamond20;
